import api from "./api";

export const getWorkspaceUsers = async () => {
  try {
    const response = await api.get(`/workspace-users/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching workspace users:", error);
    throw error;
  }
};


export const getWorkspaceUsersbyOrg = async (data) => {
  try {
    // For GET requests, pass data as query parameters
    const params = data ? { org_name: data.name } : {};

    const response = await api.get(`/workspace-users/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching workspace users:", error);
    throw error;
  }
};